module.exports = __webpack_public_path__ + "24fb0139152e6051878f652f102768f6.svg";